<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-body printableArea">
        <h3><b>Periode Surat Keluar</b></h3>
        <hr />
        <div class="row">
          <div class="col-md-12">
            <form method="post" @submit.prevent="loadItems">
              <div class="form-body">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Nomor Surat / Perihal</label>
                      <div class="controls">
                        <input
                          type="text"
                          class="form-control"
                          v-model="customFilter.document_number"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                      <CustomMulti
                        label="Kecepatan Surat"
                        :query="documentSpeed"
                        :list="documentSpeedList"
                        :model="customFilter.document_speed"
                        @data="setSearchValue('document_speed', $event)"
                        @clear="setSearchValue('document_speed', $event)"
                        toggle-clear
                        label-block
                        close-on-select
                      />
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                      <CustomMulti
                        label="Sifat Surat"
                        :query="documentUrgency"
                        :list="documentUrgencyList"
                        :model="customFilter.document_urgency"
                        @data="setSearchValue('document_urgency', $event)"
                        @clear="setSearchValue('document_urgency', $event)"
                        toggle-clear
                        label-block
                        close-on-select
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Periode Surat Start</label>
                      <div class="controls">
                        <input
                          type="date"
                          class="form-control"
                          data-date=""
                          data-date-format="YYYY-MM-DD"
                          v-model="start_date"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <div class="col-md-12">
                      <label>Periode Surat End</label>
                        <div class="controls">
                          <input
                            type="date"
                            class="form-control"
                            data-date=""
                            data-date-format="YYYY-MM-DD"
                            v-model="end_date"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                      <div class="col-md-12">
                        <label>Tanggal Target SLA</label>
                        <div class="controls">
                          <input
                            type="date"
                            class="form-control"
                            data-date=""
                            data-date-format="YYYY-MM-DD"
                            v-model="sla_date"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="form-actions">
                <div class="row">
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-offset-3 col-md-9">
                        <button
                          type="submit"
                          class="btn btn-success"
                          title="Simpan"
                        >
                          Cari</button
                        >&nbsp;
                        <!--                        <button type="button" @click="resetInput()" class="btn btn-inverse" title="Reset">Reset</button>-->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6"></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="card card-body printableArea">
        <h3>
          <div class="row">
            <div class="col-md-10 col-12">
              <b>{{ $t("document_out") }}</b>
            </div>

            <div class="col-md-2 col-12" v-if="canSeeAll">
              <select
                class="pull-right form-control"
                v-model="from"
                @change="loadItems"
                style="display:none"
              >
                <!-- <option value="me">{{ $t("self") }}</option> -->
                <option value="all">{{ $t("one_unit") }}</option>
              </select>
            </div>
          </div>
        </h3>
        <hr />
        <div class="row">
          <div class="col-md-12">
            <vue-good-table
              mode="remote"
              :pagination-options="{
                enabled: true,
                setCurrentPage: curPage,
                jumpFirstOrLast : true,
              }"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              :totalRows="total"
              :columns="columns"
              :rows="rows"
              :isLoading.sync="isLoading"
              fixed-header
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'id'">
                  <button
                    type="button"
                    @click="doDetail({ id: props.row.id })"
                    class="btn btn-success btn-sm"
                  >
                    <i class="mdi mdi-magnify"></i>
                  </button>
                  <button
                    v-if="props.row.editable"
                    type="button"
                    @click="doEdit({ id: props.row.id })"
                    class="btn btn-warning btn-sm"
                  >
                    <i class="mdi mdi-grease-pencil"></i>
                  </button>
                  <button
                    v-if="props.row.editable_approval"
                    type="button"
                    @click="openModal(props.row.id)"
                    class="btn btn-warning btn-sm"
                  >
                    <i class="mdi mdi-account-edit"></i>
                  </button>
                  <button
                    v-if="props.row.deleteable"
                    type="button"
                    @click="doDelete({ id: props.row.id })"
                    class="btn btn-danger btn-sm"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
            <!-- <Datatables table-name="suratKeluar" :trigger="{
              from:function(){
                return from
              },
              start_date : function(){
                return start_date
              },
              end_date : function(){
                return end_date
              },
              is_document_number : () => {
                return is_document_number
              },
              is_sifat_surat: () => {
                return is_sifat_surat
              },
              is_status: () => {
                return is_status;
              }
              }" @doDetail="doDetail" @doEdit="doEdit" @doDelete="doDelete" @doCancel="doCancel" :action="true" :columnFiltering="true" action-data="row_number" :url="'document_out'" :dtfields="headers">
              <template slot-scope="props">
                <button type="button" v-bind:class="{'btn disabled btn-sm btn-default':!props.ctx.data.file,'btn disabled btn-sm btn-warning':props.ctx.data.file}"
                        style="color:#fff; cursor: default;">
                  <i class="mdi mdi-file-check" v-if="props.ctx.data.file"></i>
                  <i class="mdi mdi-file-excel" v-else></i>
                </button>
                <div class="btn-group btn-sm" role="group" aria-label="Basic example">
                  <button type="button" v-if="!forbidRead" data-action="doDetail" class="btn btn-success btn-sm"><i class="mdi mdi-magnify"></i></button>
                  <button type="button" v-if="!forbidUpdate && props.ctx.data.canEdit == true" data-action="doEdit" class="btn btn-warning btn-sm"><i class="mdi mdi-grease-pencil"></i></button>
                  <button type="button" v-if="props.ctx.data.canCancel == true" data-action="doCancel" class="btn btn-danger btn-sm"><i class="mdi mdi-backup-restore"></i></button>
                </div>
              </template>
            </Datatables> -->
          </div>
        </div>
      </div>
    </div>
    <Modal
      v-show="isModalVisible"
      @close="closeModal"
      @action="onDelete(deleteData)"
      :draftingFileDetail="draftingFileDetail"
    />
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import Modal from "@/components/modal/approval.vue";

export default {
  components: {
    Modal,
  },
  data() {
    // let _this = this

    // eslint-disable-next-line no-undef
    // $.fn.dataTable.ext.errMode = "none";
    return {
      curPage: 1,
      documentSpeedList: [],
      documentUrgencyList: [],
      documentApprovalList: [
        { value: 1, text: "Approved" },
        { value: 2, text: "Pending" },
        { value: 3, text: "Decline" },
        { value: 4, text: "Revision" },
        { value: 5, text: "Retract/Cancelled" },
        { value: 6, text: "Draft" },
      ],
      documentNameList: [],
      collapse: true,
      form: {
        document_name: null,
      },
      columns: [
        { label: "Action", field: "id", sortable: false },
        { label: "Perihal", field: "subject" },
        { label: "Tanggal Surat", field: "document_date" },
        { label: "Nomor Surat", field: "document_number" },
        { label: "Pembuat / Kepada", field: "receiver" },
        { label: "Status", field: "status" },
        // { label: "Nomor Surat", field: "document_number", sortable: false },
        // { label: "Perihal", field: "subject" },
        // { label: "Tanggal", field: "document_date" },
        // { label: "Penanda Tangan", field: "signers_text", sortable: false },
        // { label: "Drafter", field: "creator.name", sortable: false },
        // { label: "Status", field: "final_approvement.name", sortable: false },
      ],
      rows: [],
      isLoading: false,
      total: 0,
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        perPage: 10,
      },
      customFilter: {
        document_number: null,
        final_approved: null,
        document_urgency: null,
        document_speed: null,
      },
      isModalVisible: false,
      currentId: 0,
      modalTitle: "",
      modalContent: "",
      isConfirmation: false,
      ActionChangeable: null,
      draftingFileDetail: {},
      // search: "",
      from: "all",
      sla_date: "",
      start_date: "",
      end_date: "",
      // is_document_number: "",
      // is_sifat_surat: "",
      // sifatSurat: [],
      // docStatus: [],
      // is_status: "",
      // headers: {
      //   subject: {
      //     label: this.$t("subject"),
      //     data: "subject",
      //   },
      //   document_date: {
      //     label: this.$t("date"),
      //     data: "document_date",
      //     render: function (data) {
      //       return new Date(data).toDateString();
      //     },
      //   },
      //   document_number: {
      //     label: this.$t("document_number"),
      //     data: "document_number",
      //   },
      //   receiver: {
      //     label: this.$t("maker") + "/" + this.$t("to"),
      //     data: "receiver",
      //   },
      //   status: {
      //     label: this.$t("status"),
      //     data: "status",
      //   },
      // },
    };
  },
  computed: {
    // items() {
    //   let data = [];
    //   if (this.$store.state.suratKeluar.items !== undefined) {
    //     if (this.$store.state.suratKeluar.items.items !== undefined) {
    //       if (
    //         !Array.isArray(this.$store.state.suratKeluar.items.items) &&
    //         this.$store.state.suratKeluar.items.items !== undefined
    //       ) {
    //         data = Object.keys(this.$store.state.suratKeluar.items.items).map(
    //           (i) => this.$store.state.suratKeluar.items.items[i]
    //         );
    //       } else {
    //         data = this.$store.state.suratKeluar.items.items;
    //       }
    //     }
    //   }
    //   data.map((element) => {
    //     element.isBold = true;
    //   });
    //   return data;
    // },
    // filters() {
    //   let filt = {};
    //   if (this.$store.state.suratKeluar.items !== undefined) {
    //     if (this.$store.state.suratKeluar.items.filters !== undefined) {
    //       filt = this.$store.state.suratKeluar.items.filters;
    //     }
    //   }
    //   return filt;
    // },
    // state() {
    //   return this.$store.state.suratKeluar;
    // },
    // forbidUpdate() {
    //   if (this.$store.state.profile.permissions.document_out) {
    //     return !this.$store.state.profile.permissions.document_out.update;
    //   }
    //   return false;
    // },
    // forbidRead() {
    //   if (this.$store.state.profile.permissions.document_out) {
    //     return !this.$store.state.profile.permissions.document_out.read;
    //   }
    //   return false;
    // },
    // forbidDel() {
    //   return true;
    // },
    canSeeAll() {
      if (this.$store.state.profile.permissions.document_out_all) {
        return this.$store.state.profile.permissions.document_out_all.read;
      }
      return false;
    },
    // // canSeeAllBulan(){
    // //   if(this.$store.state.profile.permissions.document_out_all_bulan){
    // //     return this.$store.state.profile.permissions.document_out_all_bulan.read;
    // //   }
    // //   return false;
    // // },
    // invalidBulan() {
    //   return (
    //     this.dropdownBulan.isTouched && this.dropdownBulan.value.length === 0
    //   );
    // },
  },
  // async mounted() {
  //   const state = {
  //     loaded: true,
  //     items: [],
  //     search: this.search,
  //     from: this.from,
  //     start_date: this.start_date,
  //     end_date: this.end_date,
  //     is_document_number: this.is_document_number,
  //     is_sifat_surat: this.is_sifat_surat,
  //     docStatus: [],
  //     sifatSurat: [],
  //   };
  //   this.$store.commit("suratKeluar/STATE", state);
  //   this.treeSifatSurat();
  //   this.treeStatus();
  // },
  async created() {
    let curPage = localStorage.getItem('suratKeluar.curPage');
    curPage = curPage ? curPage : 1;
    this.curPage = curPage * 1;
  },
  async mounted() {
    const state = {
      loaded: false,
      isAdd: false,
      isEdit: false,
      isDetail: false,
    };
    this.$store.commit("suratKeluar/STATE", state);
    await this.loadItems();
  },

  methods: {
    setValue(model, data) {
      this.form[model] = data;
    },
    setSearchValue(model, data) {
      this.customFilter[model] = data;
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
      localStorage.setItem('suratKeluar.curPage', params.currentPage);
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    async loadItems() {
      this.isLoading = true;

      let { perPage, page, sort } = this.serverParams;

      let {
        document_number,
        final_approved,
        document_urgency,
        document_speed,
      } = this.customFilter;

      let start = (page - 1) * perPage;
      let url =
        "document_out?perPage=" + perPage + "&page=" + start + "&jenis=surat";

      if (document_number) {
        url += "&number=" + document_number;
      }
      if (final_approved) {
        url += "&approved=" + final_approved.value;
      }
      if (document_urgency) {
        url += "&urgency=" + document_urgency.value;
      }
      if (document_speed) {
        url += "&speed=" + document_speed.value;
      }
      if (this.from) {
        url += "&from="+this.from
      }
      if (this.start_date) {
        url += "&start_date="+this.start_date
      } 
      if (this.end_date) {
        url += "&end_date="+this.end_date
      } 
      if (this.sla_date) {
        url += "&sla_date="+this.sla_date
      }

      if (sort.length) {
        sort.forEach((item, index) => {
          url +=
            `&sort[${index}][field]=${item.field}` +
            `&sort[${index}][type]=${item.type}`;
        });
      }

      let resp = await axios.get(url);

      this.rows = resp.data.data;
      this.total = resp.data.recordsTotal;

      this.isLoading = false;
    },
    documentUrgency(query) {
      axios.get(`document_urgencies/list?s=${query}`).then((res) => {
        this.documentUrgencyList = res.data.items;
      });
    },
    documentSpeed(query) {
      axios.get(`document_speeds/list?s=${query}`).then((res) => {
        this.documentSpeedList = res.data.items;
      });
    },
    documentName(query) {
      axios.get(`clasification/list-active?s=${query}`).then((res) => {
        this.documentNameList = res.data.items;
      });
    },
    goToAddView() {
      this.$store.dispatch("suratKeluar/onAdd");
    },
    doDetail(val) {
      this.$store.dispatch("suratKeluar/onDetail", val);
    },
    doEdit(val) {
      this.$store.dispatch("suratKeluar/onEdit", val);
    },
    doDelete(val) {
      this.$store.dispatch("suratKeluar/onDelete", val);
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onDelete() {
      this.isModalVisible = false;
    },
    openModal(id) {
      axios.get(`suratKeluar/${id}`).then((res) => {
        this.draftingFileDetail = res.data.data;
        this.isModalVisible = true;
      });
    },
    showModal(option) {
      this.isVisible = true;
      if (option.type == "submit") {
        if (option.data == 0) {
          this.modalTitle = "Simpan Data?";
          this.modalContent = "<p>Apakah anda yakin ingin menyimpan surat?</p>";
          this.isConfirmation = true;
          this.ActionChangeable = this.submit;
        } else if (option.data == 1) {
          this.modalTitle = "Kirim Data?";
          this.modalContent = "<p>Apakah anda yakin ingin mengirim surat?</p>";
          this.isConfirmation = true;
          this.ActionChangeable = this.submit;
        }
      } else if (option.type == "cancel") {
        this.modalTitle = "Kembali?";
        this.modalContent = "<p>Apakah anda yakin ingin kembali?</p>";
        this.isConfirmation = true;
        this.ActionChangeable = this.goBack;
      }
    },
    changeDt() {
      this.$children[0].$refs.table.reload();
    },
  },

  // methods: {
  //   // treeSifatSurat(){
  //   //   axios.get(`/typeSurat/list-select`).then( res => {
  //   //     this.sifatSurat = res.data.data;
  //   //   })
  //   // },
  //   treeSifatSurat() {
  //     axios.get(`/document_urgencies/list`).then((res) => {
  //       this.sifatSurat = res.data.items;
  //     });
  //   },
  //   treeStatus() {
  //     axios.get(`/clasification/list-status`).then((res) => {
  //       this.docStatus = res.data.data;
  //     });
  //   },
  //   onSearch(val) {
  //     this.search = val;
  //   },
  //   get(val) {
  //     this.$store.dispatch("suratKeluar/getSuratKeluar", val);
  //   },
  //   resetInput() {
  //     this.start_date = moment().startOf("year").format("YYYY-MM-DD");
  //     this.end_date = moment().endOf("year").format("YYYY-MM-DD");
  //     const state = {
  //       loaded: false,
  //       items: [],
  //       from: this.from,
  //       search: this.search,
  //       start_date: this.start_date,
  //       end_date: this.end_date,
  //       is_document_number: this.is_document_number,
  //       is_sifat_surat: this.is_sifat_surat,
  //       is_status: this.is_status,
  //     };
  //     this.$store.commit("suratKeluar/STATE", state);
  //     this.get(state);
  //   },
  //   filterData: function () {
  //     const state = {
  //       loaded: false,
  //       items: [],
  //       from: this.from,
  //       search: this.search,
  //       start_date: this.start_date,
  //       end_date: this.end_date,
  //       is_document_number: this.is_document_number,
  //       is_sifat_surat: this.is_sifat_surat,
  //       is_status: this.is_status,
  //     };
  //     this.$store.commit("suratKeluar/STATE", state);
  //     this.get(state);
  //   },
  //   doDetail(val) {
  //     // this.$store.dispatch("suratKeluar/onDetail", val);
  //     const idsurat = val.id;
  //     let route = this.$router.resolve({ path: "/suratKeluar/detail" });
  //     let route1 = `${route.href}/${idsurat}`;
  //     window.open(route1, "_blank");
  //   },
  //   doCancel(val) {
  //     this.$store.dispatch("suratKeluar/onRetract", val);
  //   },
  //   doEdit(val) {
  //     this.$store.dispatch("suratKeluar/onEdit", val);
  //   },
  //   doDelete(val) {
  //     this.$store.dispatch("suratKeluar/submitDelete", val);
  //   },

  //   // start Bulan
  //   bulan(query) {
  //     this.dropdownBulan.isLoadingBulan = true;
  //     axios
  //       .get(`bulan/list?s=${query}`)
  //       .then((res) => {
  //         this.dropdownBulan.bulanList = res.data.items;
  //         this.dropdownBulan.isLoadingBulan = false;
  //       })
  //       .catch((err) => {
  //         if (err.response.status === 401) {
  //           this.$store.commit("auth/LOGOUT");
  //         }
  //       });
  //   },
  //   // onTouchBulan() {
  //   //   this.dropdownBulan.isTouched = true;
  //   // },
  //   // onChangeBulan(value) {
  //   //   this.dropdownBulan.value = value;
  //   // },

  //   // end Bulan

  //   getFrom() {
  //     const state = {
  //       loaded: false,
  //       items: [],
  //       from: this.from,
  //       search: this.search,
  //       start_date: this.start_date,
  //       end_date: this.end_date,
  //       is_document_number: this.is_document_number,
  //       is_sifat_surat: this.is_sifat_surat,
  //       is_status: this.is_status,
  //     };
  //     this.$store.commit("suratKeluar/STATE", state);
  //     this.get(state);
  //   },
  // },
};
</script>